// components/ThemeToggle.tsx
'use client'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

export default function ThemeToggle() {
  const { theme, setTheme, systemTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  // Avoid rendering different HTML on server vs client
  if (!mounted) {
    return (
      <button
        type="button"
        aria-label="Toggle theme"
        className="p-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/10"
      >
        ◐
      </button>
    )
  }

  const current = theme === 'system' ? systemTheme : theme
  const next = current === 'dark' ? 'light' : 'dark'

  return (
    <button
      type="button"
      onClick={() => setTheme(next!)}
      aria-label="Toggle theme"
      className="p-2 rounded-lg hover:bg-black/5 dark:hover:bg-white/10"
      title={`Switch to ${next} mode`}
    >
      {current === 'dark' ? '🌙' : '☀️'}
    </button>
  )
}
